import { apiList } from "../api/apiList";
import axiosInstance2 from "../api/axiosInstance2";

const bufferZoneService = {
  getEvents: (params) =>
    axiosInstance2.get(apiList.getBufferZoneEventsApi, {
      params,
    }),
  saveSelections: (payload) =>
    axiosInstance2.post(`${apiList.saveBufferZoneSelectionsApi}`, payload),
  updateAllHandicaps: (payload) =>
    axiosInstance2.post(apiList.updateAllBufferHandicapsApi, payload),
  updateEventHandicap: (eventId) =>
    axiosInstance2.get(`${apiList.updateEventHandicapApi}/${eventId}`),
  saveEventHandicap: (payload) =>
    axiosInstance2.post(`${apiList.saveEventHandicapApi}`, payload),
  getStatusResponse: () => 
    axiosInstance2.get(apiList.getStatusResponseApi),
  saveMultipleSiteBettings : (baseUrl) => 
    axiosInstance2.post(`${baseUrl}/${apiList.saveMultipleSiteBettingsApi}`),
  updateOddsManual: (payload) => 
    axiosInstance2.post(`${apiList.updateOddsManual}`, payload),
};

export default bufferZoneService;

